import { environmentService } from '@core/services/Environment.service';

const API_PREFIX = 'pc';

const URL = {
  tokenRefresh: `/${API_PREFIX}/v1/auth/token/refresh`,
  users: `/${API_PREFIX}/v1/users`,
  abcloudzLogin: `/${API_PREFIX}/v1/auth/login/anonymous`,
  flow: `/${API_PREFIX}/v1/flows`,
  flowsChatStream: `${environmentService.baseUrl}/${API_PREFIX}/v1/flows`
} as const;

export { URL };
